<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect opacity="0.2" x="2" y="2" width="16" height="16" rx="8" fill="currentColor"/>
<rect x="9" y="9" width="2" height="5" fill="currentColor"/>
<rect x="9" y="6" width="2" height="2" fill="currentColor"/>
</svg>
